exports = module.exports = require("../../../../node_modules/_css-loader@0.28.11@css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".popover {\n  background: rgba(0,0,0,0.6);\n  width: 200px;\n  height: 100px;\n  border-radius: 20px;\n  position: fixed;\n  top: 50%;\n  left: 50%;\n  z-index: 999;\n}\n.popover p {\n  color: #fff;\n  height: 100px;\n  line-height: 100px;\n  text-align: center;\n}\n", ""]);

// exports


/*** EXPORTS FROM exports-loader ***/
module.exports = module.exports.toString();


//////////////////
// WEBPACK FOOTER
// /Users/apple/Documents/object/chinaicac-portal/src/app/share/pop/pop.component.styl
// module id = ../../../../../src/app/share/pop/pop.component.styl
// module chunks = main